import React, { useEffect, useRef, useState } from 'react'
import CustomerNotePopup from '../../components/CustomerNotePopup'
import defaultImage from '../../img/example.png'
import useAccountStore from '../../stores/account'
import { BASEURL } from '../../config'
import axios from 'axios'

const CustomerList = (props:any) => { 
    const {selectedCustomers, setSelectedCustomers} = props
    
    const {accessToken} = useAccountStore()
    const [selectedTab, setSelectedTab] = useState("")

    const [newCustomers, setNewCustomers] = useState<any[]>([])
    const [regularCustomers, setRegularCustomers] = useState<any[]>([])
    const [potentialCustomers, setPotentialCustomers] = useState<any[]>([])
    const [allCustomers, setAllCustomers] = useState<any[]>([])

    const [isAllcheckNew, setIsAllcheckNew] = useState(false)
    const [isAllcheckRegular, setIsAllcheckRegular] = useState(false)
    const [isAllcheckPotential, setIsAllcheckPotential] = useState(false)
    const [isAllcheckAll, setIsAllcheckAll] = useState(false)

    const [showCustomerNotePopup, setCustomerNotePopup] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState<any>(null)
    const [coordinates, setCoordinates] = useState({ top: 0, left: 0 })
    
    const popRef = useRef<HTMLDivElement>(null)
    
    useEffect(()=> {
        if(!accessToken) return
        getCustomerList()
    },[accessToken])

    const getCustomerList = async() => {
        try {
            axios.get(`${BASEURL}/customer/list`, { headers: {Authorization: `Bearer ${accessToken}`, }})
            .then(response => response.data)
            .then(obj => {
                if(obj.status === "success") { 
                    // 1 : 잠재고객 (예약이 잡히지 않은 고객), 2 : 신규고객 (예약이 잡힌 고객), 3 : 단골고객(방문 2회이상)
                    const data = obj.data
                    const potentialCst = data.filter((item:any)=>item.gradeID === 1)
                    const newCst = data.filter((item:any)=>item.gradeID === 2)
                    const regularCst = data.filter((item:any)=>item.gradeID === 3)
                    
                    setPotentialCustomers(potentialCst)
                    setNewCustomers(newCst)
                    setRegularCustomers(regularCst)
                    setAllCustomers(data)
                 }
            }).catch(error => {
                if(error.response) {
                    // temp error handling
                    if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                    if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                    if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                }
                else { console.log(error) }
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{ updateCheckedCustomers() },[selectedCustomers])

    const updateCheckedCustomers = ()=> {
        setIsAllcheckNew(newCustomers.every((newCustomer) => selectedCustomers.includes(newCustomer)))
        setIsAllcheckRegular(regularCustomers.every((regularCustomer) => selectedCustomers.includes(regularCustomer)))
        setIsAllcheckPotential(potentialCustomers.every((potentialCustomer) => selectedCustomers.includes(potentialCustomer)))
        setIsAllcheckAll(allCustomers.every((allCustomer) => selectedCustomers.includes(allCustomer)))
    }

    const getTargetCustomers = (target:string) => {
        if(target === "new") return newCustomers
        else if(target === "regular") return regularCustomers
        else if(target === "potential") return potentialCustomers
        else if(target === "all") return allCustomers
        else return []
    }

    const handleAllCheck = (e:any, sort:any) => {
        e.stopPropagation()
        let targetCustomers:any = getTargetCustomers(sort)
        if(e.target.checked) setSelectedCustomers([...selectedCustomers, ...targetCustomers])
        else {
            const newSelectedCustomers = selectedCustomers.filter((customer:any) => !targetCustomers.includes(customer))
            setSelectedCustomers([...newSelectedCustomers])
        }
    }

    const handleMoreClick = (e:any) => {
        e.stopPropagation()

        const sWidth = window.innerWidth
        const sHeight = window.innerHeight
        
        const oWidth = popRef.current ? popRef.current.offsetWidth : 0
        const oHeight = popRef.current ? popRef.current.offsetHeight : 0
        
        let divLeft = e.clientX + 10
        let divTop = e.clientY + 10
    
        if (divLeft + oWidth > sWidth) divLeft -= oWidth
        if (divTop + oHeight > sHeight) divTop -= oHeight

        if (divLeft < 0) divLeft = 0
        if (divTop < 0) divTop = 0
    
        setCoordinates({ top: divTop, left: divLeft })
    }

    useEffect(() => { if (coordinates.top !== 0 || coordinates.left !== 0) setCustomerNotePopup(true)}, [coordinates])
    
    const CustomerItem = ({info}:any) => {
        const isSelected = selectedCustomers.includes(info)

        const selectCustomer = (e:any) => {
            e.stopPropagation()
            if(isSelected) {
                const newSelectedCustomers = selectedCustomers.filter((customer:any) => customer.gradeID !== info.gradeID)
                setSelectedCustomers([...newSelectedCustomers])
            } else setSelectedCustomers([...selectedCustomers, info])
        }

        return (
            <div className={`cst_item${isSelected ? ' on' : ''}`} onClick={selectCustomer}>
                <div className="profile_container">
                    <div className="profile">
                        <img src={defaultImage} alt="고객이미지"/>
                    </div>
                    <div className="tit">
                        <p>{`${info.petName}(${info.guardianName})`}</p>
                    </div>
                </div>
                <div className="more" onClick={(e)=>{
                    setSelectedCustomer(info)
                    handleMoreClick(e)
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M6.99968 4.08333C7.23042 4.08333 7.45598 4.01491 7.64784 3.88671C7.8397 3.75852 7.98923 3.57631 8.07753 3.36313C8.16584 3.14995 8.18894 2.91537 8.14392 2.68906C8.09891 2.46275 7.98779 2.25487 7.82463 2.09171C7.66147 1.92855 7.45359 1.81743 7.22728 1.77242C7.00097 1.7274 6.76639 1.75051 6.55321 1.83881C6.34003 1.92711 6.15782 2.07664 6.02963 2.2685C5.90143 2.46036 5.83301 2.68592 5.83301 2.91667C5.83301 3.22609 5.95592 3.52283 6.17472 3.74163C6.39351 3.96042 6.69026 4.08333 6.99968 4.08333ZM6.99968 9.91667C6.76893 9.91667 6.54337 9.98509 6.35151 10.1133C6.15965 10.2415 6.01012 10.4237 5.92182 10.6369C5.83351 10.85 5.81041 11.0846 5.85543 11.3109C5.90044 11.5372 6.01156 11.7451 6.17472 11.9083C6.33788 12.0715 6.54576 12.1826 6.77207 12.2276C6.99838 12.2726 7.23296 12.2495 7.44614 12.1612C7.65932 12.0729 7.84153 11.9234 7.96972 11.7315C8.09792 11.5396 8.16634 11.3141 8.16634 11.0833C8.16634 10.7739 8.04343 10.4772 7.82463 10.2584C7.60584 10.0396 7.30909 9.91667 6.99968 9.91667ZM6.99968 5.83333C6.76893 5.83333 6.54337 5.90176 6.35151 6.02995C6.15965 6.15815 6.01012 6.34036 5.92182 6.55354C5.83351 6.76672 5.81041 7.00129 5.85543 7.22761C5.90044 7.45392 6.01156 7.6618 6.17472 7.82496C6.33788 7.98812 6.54576 8.09923 6.77207 8.14425C6.99838 8.18927 7.23296 8.16616 7.44614 8.07786C7.65932 7.98956 7.84153 7.84002 7.96972 7.64817C8.09792 7.45631 8.16634 7.23075 8.16634 7C8.16634 6.69058 8.04343 6.39384 7.82463 6.17504C7.60584 5.95625 7.30909 5.83333 6.99968 5.83333Z" fill="black"/>
                    </svg>
                </div>
            </div>
        )
    }

    const handleTab = (tabName:string) => {
        if(selectedTab === tabName) setSelectedTab("") 
        else setSelectedTab(tabName)
    }

    const PotentialCustomer = () => {
        return (
            <div className={`potential customer ${selectedTab === "potential" ? 'selected' : ''}`} onClick={()=>handleTab("potential")}>
                <div className="top">
                    <label htmlFor="potential_cst">잠재고객</label>
                    <input type="checkbox"
                    checked={isAllcheckPotential}
                    id="potential_cst" className="checkAll"
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e)=>handleAllCheck(e, "potential")}/>

                    <span className="num">{`(${potentialCustomers.length})`}</span>
                </div>
                <div className="wrap_box">
                     { potentialCustomers.map((info:any) => <CustomerItem info={info}/>) }
                </div> 
            </div>
        )
    }

    const NewCustomer = () => {
        return (
            <div className={`new customer ${selectedTab === "new" ? 'selected' : ''}`} onClick={()=>handleTab("new")}>
                <div className="top">
                    <label htmlFor="new_cst">신규고객</label>
                    <input type="checkbox"
                    checked={isAllcheckNew} 
                    id="new_cst" className="checkAll" 
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e)=>handleAllCheck(e, "new")}/>
                    <span className="num">{`(${newCustomers.length})`}</span>
                </div>
                <div className="wrap_box">
                    { newCustomers.map((info:any) => <CustomerItem info={info}/>) }
                </div>
            </div>
        )
    }

    const RegularCustomer = () => {
        return (
            <div className={`regular customer ${selectedTab === "regular" ? 'selected' : ''}`} onClick={()=>handleTab("regular")}>
                <div className="top">
                    <label htmlFor="regular_cst">단골고객</label>
                    <input type="checkbox"
                    checked={isAllcheckRegular}
                    id="regular_cst" className="checkAll"
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e)=>handleAllCheck(e, "regular")}/>
                    <span className="num">{`(${regularCustomers.length})`}</span>
                </div>
                <div className="wrap_box">
                   { regularCustomers.map((info:any) =><CustomerItem info={info}/>) }
                </div>
            </div>
        )
    }

    const AllCustomer = () => {
        return (
            <div className={`all customer ${selectedTab === "all" ? 'selected' : ''}`} onClick={()=>handleTab("all")}>
                <div className="top">
                    <label htmlFor="all_cst">전체고객</label>
                    <input type="checkbox"
                    checked={isAllcheckAll}
                    id="all_cst" className="checkAll"
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e)=>handleAllCheck(e, "all")}/>
                    <span className="num">{`(${allCustomers.length})`}</span>
                </div>
                <div className="wrap_box">
                    { allCustomers.map((info:any) => <CustomerItem info={info}/>) }
                </div> 
            </div>
        )
    }

    return (
        <div className="customer_list">
            <PotentialCustomer/>
            <NewCustomer/>
            <RegularCustomer/>
            <AllCustomer/>
            {/* *  수첩정보 팝업 */}
            <CustomerNotePopup
            popRef={popRef}
            data={selectedCustomer}
            coordinates={coordinates}
            showNotePopup={showCustomerNotePopup}
            setShowNotePopup={setCustomerNotePopup}/>
        </div>
    )
}

export default CustomerList